import React, { Fragment, useEffect } from 'react';
import Button from '../../components/button/Button';
import Popup from './Popup';
import { usePopupContext } from '../contexts/PopupContext';
import CheckboxButton from '../buttons/CheckboxButton';
import { BUTTONS_TEXT } from '../../constants/popups';
import { useAppContext } from '../contexts/AppContext';
import { linkOnClickHandler } from '../navigation/navigation';
import { handleEnterKeyPress } from './utils';

const CHECKBOX_TEXT = 'Do not show this message again.';
const MESSAGE_UPDATE_LINK = (
    <span>
        passage located{' '}
        <a
            href="https://mclass.amplify.com/support_center/D8_BM_ORF_G5_BOY_2021Update.pdf"
            rel="noopener noreferrer"
            target="_blank"
        >
            here <i className='dashboard-navigation-link-icon' />
        </a>{' '}
        or cover up the first line of the outdated passage{' '}
    </span>
);

const MESSAGE = [
    'The Grade 5 BOY Benchmark passage has been updated to remove the first',
    <br />,
    'line from the original passage. Please confirm you are using the latest version',
    <br />,
    'before continuing to assess your students.',
    <br />,
    <br />,
    'If the student materials you have show the first line as: “Everyone needs to',
    <br />,
    'breathe. If we did not breathe, we would die.” then you should print the new',
    <br />,
    MESSAGE_UPDATE_LINK,
    <br />,
    'before providing it to your students.',
];

const displayMessage = MESSAGE.map((item, index) => (
    <Fragment key={index.toString()}>{item}</Fragment>
));

const WarningDiffFormPopup = () => {
    const {
        userPopupsSettings,
        params: { linkToAssessment },
        actions: { hideOrfG5BoyFormPopup, enableVisiblityOrfG5BoyFormPopup },
    } = usePopupContext();

    const isDevEnv = process.env.NODE_ENV === 'development';
    const dashboardPrefix = isDevEnv ? '' : 'dashboard-';

    const checkmarkSelector = `.${dashboardPrefix}checkmark`;

    useEffect(() => {
        const checkmark = document.querySelector(checkmarkSelector);

        if (checkmark) {
            checkmark.addEventListener('keydown', handleEnterKeyPress);
        }

        // code below is candidate to remove
        return () => {
            if (checkmark) {
                checkmark.removeEventListener('keydown', handleEnterKeyPress);
            }
        };
    }, []);

    const { checkAndGetSessionStatus } = useAppContext();

    const onChange = () => {
        enableVisiblityOrfG5BoyFormPopup(!userPopupsSettings.isOrfG5BoyFormPopupEnable);
    };

    const onCancel = () => {
        hideOrfG5BoyFormPopup();
        enableVisiblityOrfG5BoyFormPopup(true);
    };

    const startAssessment = linkOnClickHandler(linkToAssessment, checkAndGetSessionStatus);

    return (
        <Popup
            header={<p>G5 ORF BOY Passage Updated</p>}
            message={<>{displayMessage}</>}
            buttons={[
                <Button key="cancel-button" onClick={onCancel}>
                    {BUTTONS_TEXT.CANCEL}
                </Button>,
                <Button key="continue-button" onClick={startAssessment}>
                    {BUTTONS_TEXT.CONTINUE}
                </Button>,
                <div key="chb-button-1" className='dashboard-do-not-show-chb'>
                    <CheckboxButton
                        key="chb-button-2"
                        name={CHECKBOX_TEXT}
                        id="checkbox-input"
                        value="marked"
                        isChecked={!userPopupsSettings.isOrfG5BoyFormPopupEnable}
                        onChange={onChange}
                    />
                </div>,
            ]}
            cssClass="show-warning-diff-form-popup"
        />
    );
};

export default WarningDiffFormPopup;
